import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'addOrdinalInDate'
})
export class AddOrdinalInDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
  	 var arr = value.split(' ');
  	 var i = arr[0];
  	 var j = arr[0] % 10;
  	 var k = arr[0] % 100;
    if (j == 1 && k != 11) {
        i =  i + "<sup>st</sup>";
    }
    else if (j == 2 && k != 12) {
        i = + "nd";
    }
    else if (j == 3 && k != 13) {
        i = + "rd";
    }
    else
    {
    	i =  i + "<sup>st</sup>";
    }
    return i + "<sup>st</sup>" +" " +arr[1]+" "+arr[2];
  }

}
